export const adaptPersonPayload = (
	values: PersonFormValues
): Record<string, unknown> => {
	return {
		name: values.name,
		email: values.email,
		role: values.role,
		employee_id: values.employeeId,
		store: values.store ? Number(values.store) : null
	};
};
